import React from 'react';
import { Card, FlexRow, FormCell, Grid, Header2Text, NavigationItem } from 'ui-toolkit';
import { ILenderInformationData } from '../../types/lenders/ILenderInformation';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';
import { prettyLenderFeeType } from '../../ui-toolkit/orders/interfaces/ILenderInformation';
import { propertyAddressToString } from '../../ui-toolkit/orders/interfaces/IPropertyAddress';

interface ILenderDetailsProps {
  lender: ILenderInformationData;
}

export const LenderDetails: React.FC<ILenderDetailsProps> = ({ lender }) => (
  <Grid columnCount={3}>
    <Card>
      <Grid>
        <FlexRow justifyContent={'space-between'}>
          <Header2Text>Lender Details</Header2Text>
          <NavigationItem text={'Edit'} isActive href={ClientUrlFactory().urlFor.lenderCompanyEdit(lender.lender.id)} />
        </FlexRow>
        <FormCell label={'Name'}>{lender.lender.name}</FormCell>
        <FormCell label={'Property Address'}>{propertyAddressToString(lender.address)}</FormCell>
        <FormCell label={'Master Email'}>
          <NavigationItem text={lender.lender.masterEmail || '-'} href={`mailto:${lender.lender.masterEmail}`} />
        </FormCell>
        <FormCell label={'Mortgage Clause'}>{lender.lender.mortgageeClause || '-'}</FormCell>
        <FormCell label={'Refinance Product Type'}>{prettyLenderFeeType[lender.lender.defaultFeeType]}</FormCell>
        <FormCell label={'Qualifies for Bulk Refinance Premiums'}>
          {lender.lender.bulkRateQualified ? 'Yes' : 'No'}
        </FormCell>
        <FormCell label={'Discounted Closing Fee (Refinance Transactions)'}>
          {lender.lender.refiDiscountedClosingFee ? 'Yes' : 'No'}
        </FormCell>
      </Grid>
    </Card>

    <Card>
      <Grid>
        <FlexRow justifyContent={'space-between'}>
          <FormCell hintText={'Number of pages for recording fees'}>
            <Header2Text>Refinance</Header2Text>
          </FormCell>
          <NavigationItem text={'Edit'} href={ClientUrlFactory().urlFor.lenderCompanyEdit(lender.lender.id)} isActive />
        </FlexRow>
        <FormCell label={'Lien Release'}>{lender.refiPageCounts.lienReleasePages || '-'}</FormCell>
        <FormCell label={'Mortgage'}>{lender.refiPageCounts.mortgagePages || '-'}</FormCell>
        <FormCell label={'Deed'}>{lender.refiPageCounts.deedPages || '-'}</FormCell>
        <FormCell label={'Notice of settlement'}>{lender.refiPageCounts.noticeOfSettlementPages || '-'}</FormCell>
        <FormCell label={'Subordination agreement'}>{lender.refiPageCounts.memorandumPages || '-'}</FormCell>
        <FormCell label={'Assignment'}>{lender.refiPageCounts.assignmentPages || '-'}</FormCell>
      </Grid>
    </Card>

    <Card>
      <Grid>
        <FlexRow justifyContent={'space-between'}>
          <FormCell hintText={'Number of pages for recording fees'}>
            <Header2Text>Purchase</Header2Text>
          </FormCell>
          <NavigationItem text={'Edit'} href={ClientUrlFactory().urlFor.lenderCompanyEdit(lender.lender.id)} isActive />
        </FlexRow>
        <FormCell label={'Lien Release'}>{lender.purchasePageCounts.lienReleasePages || '-'}</FormCell>
        <FormCell label={'Mortgage'}>{lender.purchasePageCounts.mortgagePages || '-'}</FormCell>
        <FormCell label={'Deed'}>{lender.purchasePageCounts.deedPages || '-'}</FormCell>
        <FormCell label={'Notice of settlement'}>{lender.purchasePageCounts.noticeOfSettlementPages || '-'}</FormCell>
        <FormCell label={'Subordination agreement'}>{lender.purchasePageCounts.memorandumPages || '-'}</FormCell>
        <FormCell label={'Assignment'}>{lender.purchasePageCounts.assignmentPages || '-'}</FormCell>
      </Grid>
    </Card>
  </Grid>
);
